import {alpha2ToAlpha3LanguageCode} from '@/common/constants/language';
import {MainPageLocationMode, Preferences} from '@/app/interfaces/preferences';
import {AbstractFetcher} from '@/common/services/fetcher/AbstractFetcher';
import {preferencesParser} from '../helpers/preferencesHelpers';

const mainPageLocationToServerValueMap: Record<MainPageLocationMode, string> = {
	determine: 'determine',
	defined: 'user_default',
};

export const getPreferences = (fetcher: AbstractFetcher) => async (fieldSetOnly?: 'overall' | 'personalized') => {
	const {preference} = await fetcher.fetch('/api/config/preference/get');
	return preferencesParser(preference, fieldSetOnly);
};

export const setPreferences = (fetcher: AbstractFetcher) => async (preferences: Partial<Preferences>) => {
	await fetcher.fetch('/api/config/preference/set', {
		preference: {
			/* eslint-disable @typescript-eslint/naming-convention */
			lang: preferences.lang ? alpha2ToAlpha3LanguageCode[preferences.lang] : undefined,
			temperature_unit: preferences.temperatureUnit,
			pressure_unit: preferences.pressureUnit,
			speed_unit: preferences.speedUnit,
			clock_type: preferences.clockType,
			weather_view:
				preferences.weatherViewMode || preferences.weatherViewHiddenFields
					? {
							display_mode: preferences.weatherViewMode,
							hide_fields: preferences.weatherViewHiddenFields,
						}
					: undefined,
			main_page_location: mainPageLocationToServerValueMap[preferences.mainPageLocationMode!],
			default_location:
				preferences.hasOwnProperty('defaultLocationId') && preferences.defaultLocationId === undefined
					? null // Workaround to save an empty value
					: preferences.defaultLocationId,
			/* eslint-enable @typescript-eslint/naming-convention */
		},
	});
};
